import { render, staticRenderFns } from "./Quotation_detail.vue?vue&type=template&id=db8d8c24&scoped=true&"
import script from "./Quotation_detail.vue?vue&type=script&lang=js&"
export * from "./Quotation_detail.vue?vue&type=script&lang=js&"
import style0 from "./Quotation_detail.vue?vue&type=style&index=0&id=db8d8c24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8d8c24",
  null
  
)

export default component.exports